import Seo from "@/components/Seo";
import { PageHero, SectionHead, CTABand } from "@/components/Section";
import { Reveal } from "@/components/Reveal";
import { PROJECTS } from "@/data/site";

export default function Projects() {
  return (
    <>
      <Seo
        title="Projects & Impact — BNM Sustainable Energy Limited"
        description="BNM initiatives including Powering Learning Without Limits and Salone Agro Rider — energy-access and clean-energy programmes in development in Sierra Leone."
      />
      <PageHero
        testid="projects-hero"
        dark={false}
        eyebrow="Projects & Impact"
        lines={["Technology is only", "half the story."]}
        lead="BNM's initiatives apply clean-energy technology where it matters most — learning, livelihoods and community resilience. Project documentation is published as programmes are formalised."
      />

      <section data-testid="projects-grid" className="bg-mist">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-28">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 lg:gap-6">
            {PROJECTS.map((p, i) => (
              <Reveal key={p.name} delay={i * 0.1}>
                <article className="h-full rounded-lg border border-slate-200 bg-white p-8 lg:p-10 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-emerald-300">
                  <div className="flex flex-wrap items-center justify-between gap-3">
                    <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-emerald-600">{p.tag}</p>
                    <span className="rounded-full border border-dashed border-slate-300 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.14em] text-slate-500">
                      {p.status}
                    </span>
                  </div>
                  <h2 className="mt-5 font-display text-xl sm:text-2xl font-bold tracking-tight text-slate-900">
                    {p.name}
                  </h2>
                  <p className="mt-4 text-sm sm:text-base leading-relaxed text-slate-600">{p.text}</p>
                </article>
              </Reveal>
            ))}
            <Reveal delay={0.2}>
              <article className="h-full rounded-lg border border-dashed border-slate-300 bg-mist p-8 lg:p-10 flex flex-col justify-center md:col-span-2 lg:col-span-1">
                <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-slate-500">Pipeline</p>
                <h2 className="mt-4 font-display text-xl font-bold tracking-tight text-slate-900">
                  Future energy & sustainability projects
                </h2>
                <p className="mt-3 text-sm leading-relaxed text-slate-600">
                  New BNM initiatives will be announced here as they are confirmed — with verified partners,
                  locations and outcomes.
                </p>
              </article>
            </Reveal>
          </div>

          <Reveal delay={0.15}>
            <div className="mt-14 rounded-lg border border-slate-200 bg-white p-8 lg:p-10">
              <SectionHead
                eyebrow="Our Impact Philosophy"
                title="Measured, verified, then published."
                lead="BNM does not report impact numbers before they exist. When our programmes reach communities, this page will carry verified outcomes — beneficiary counts, locations and results — documented with our partners."
              />
            </div>
          </Reveal>
        </div>
      </section>

      <CTABand
        title="Have an energy-access programme in mind?"
        text="NGOs, development organisations and government institutions: let's explore where BNM technology can serve."
        primary={{ label: "Start a Conversation", to: "/contact", testid: "projects-contact-cta" }}
        secondary={{ label: "Partner With BNM", to: "/partners", testid: "projects-partner-cta" }}
        testid="projects-cta"
      />
    </>
  );
}
